import { Box, Skeleton } from "@mui/material"
import { ButtonsWrapper, ProductCard, ProductThumbnailWrapper, ProductTitle } from "./ProductDesign"

interface Props {
  listView?: boolean
  showActions?: boolean
  showSelection?: boolean
  showSecondaryActions?: boolean
}

export function ProductSkeleton(props: Props) {
  const showActions = props.showActions ?? true
  const showSelection = props.showSelection ?? true
  const showSecondaryActions = props.showSecondaryActions ?? true

  return <ProductCard
    elevation={0}
    className={props.listView ? 'list-view' : undefined}
    sx={{
      backgroundColor: props.listView ? 'transparent' : 'rgba(0, 0, 0, 0.11)',
      boxShadow: 'none',
    }}
  >
    {props.listView && showSelection ? <Box
      component="div"
      sx={{
        width: 42,
        height: 42,
        flexShrink: 0,
        mr: 2,
      }}
    /> : null}
    <ProductThumbnailWrapper>
      <Box
        component="div"
        sx={{
          aspectRatio: '1120 / 1000',
          backgroundColor: props.listView ? 'rgba(0, 0, 0, 0.11)' : 'transparent',
          borderRadius: props.listView ? '15px' : 0,
          width: '100%',
        }}
      />
    </ProductThumbnailWrapper>
    <ProductTitle
      sx={{
        backgroundColor: props.listView ? 'transparent' : '#f0f0f0',
      }}
    >
      <Skeleton variant="text" width={props.listView ? '32%' : '75%'} height={24} />
      <Skeleton variant="text" width={props.listView ? '24%' : '45%'} height={18} />
    </ProductTitle>
    {showActions ? <ButtonsWrapper
      style={{
        backgroundColor: props.listView ? 'transparent' : '#f0f0f0',
      }}
    >
      <Skeleton variant="rounded" width={78} height={36} />
      {showSecondaryActions ? <Box
        component="div"
        sx={{
          width: 48,
          height: 48,
          flexShrink: 0,
        }}
      /> : null}
    </ButtonsWrapper> : null}
  </ProductCard>
}
